import React, { useRef } from 'react';
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  InputGroup,
  Modal,
  Row,
  Tab,
  Table,
  Tabs,
} from 'react-bootstrap';
import { useState } from 'react';
import { formatNumberWithout, getLink } from '../helper';
import axios from 'axios';
import { Eye, Info, Mail, User } from 'react-feather';
import Seat from './Seat/SeatMap';
import InputGroupText from 'react-bootstrap/esm/InputGroupText';

const Home = () => {
  const csNumber = '6282336441318';
  const [emailVal, setEmailVal] = useState('');
  const [modalSeatMap, setModalSeatMap] = useState(false);
  const [disableRes, setDisableRes] = useState(false);
  const [seatMap, setSeatMap] = useState([]);
  const [seatMapSelectId, setSeatMapSelectId] = useState([]);
  const [customerData, setCustomerData] = useState({});
  const [selectedSeat, setSeatSelect] = useState('');
  const [listSeatSelected, setListSeatSelected] = useState('');
  const [priceSeatSelected, setPriceSeatSelected] = useState('');
  const [selectedTicketId, setSelectedTicketId] = useState('');
  const [selectedTicketIdRes, setSelectedTicketIdRes] = useState('');
  const [bookingData, setBookingData] = useState([]);
  const [optionSeat, setOptionSeat] = useState([]);
  const [seatBooked, setSeatBooked] = useState([]);
  const [selectedSeatIds, setSelectedIds] = useState([]);
  const [bookingStatus, setBookingStatus] = useState(false);
  const [key, setKey] = useState('home');
  const [emailStatus, setEmailStatus] = useState(false);
  const [indexSelect, setIndexSelect] = useState('');
  const section3Ref = useRef(null);

  const [paymentMethod, setPaymentMethod] = useState('');

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  const handleBooking = async () => {
    if (emailVal === '') {
      return alert('Email Tidak Boleh Kosong');
    }

    const params = {
      email: emailVal,
    };

    try {
      const response = await axios(
        `${process.env.REACT_APP_API_URL}/seating-soul-extra/getBooking`,
        {
          headers: {
            'Content-Type': 'application/json',
            token: process.env.REACT_APP_API_KEY,
          },
          method: 'POST',
          data: JSON.stringify(params),
        },
      );


      if (response.data.status) {
        setEmailStatus(true);
        setCustomerData(response.data.data.data);
        setBookingData(response.data.data.booking);
        const combine = combineTickets(response.data.data.booked_seats);
        setSeatBooked(combine);
        setBookingStatus(response.data.data.booking.length >= 0 ? true : false);
        setKey(
          `${response.data.data.booking[0].ticket_id}-${response.data.data.booking[0].booking_code}`,
        );
        getRecomendation(
          `${response.data.data.booking[0].ticket_id}-${response.data.data.booking[0].booking_code}`,
        );
      } else {
        alert('Pemesanan Tidak Ditemukan, Periksa Kembali Email Anda');
      }
    } catch (error) {}
  };

  const handleRemoveState = () => {
    setSeatMap([]);
    setSeatMapSelectId([]);
    setCustomerData({});
    setSeatSelect('');
    setListSeatSelected('');
    setPriceSeatSelected('');
    setSelectedTicketId('');
    setBookingData([]);
    setOptionSeat([]);
    setSeatBooked([]);
    setBookingStatus(false);
    setKey('home');
    setEmailStatus(false);
    setEmailVal('');
    setIndexSelect('');
    setPaymentMethod('');
  };

  const getRecomendation = async (key) => {
    try {
      const keys = key.split('-');
      const ticket_id = keys[0].trim();
      const booking_id = keys[1].trim();
      setSelectedTicketIdRes(ticket_id);
      const params = {
        ticket_id: ticket_id,
        booking_id: booking_id,
      };
      const response = await axios(
        `${process.env.REACT_APP_API_URL}/seating-soul-extra/getRecomendation`,
        {
          headers: {
            'Content-Type': 'application/json',
            token: process.env.REACT_APP_API_KEY,
          },
          method: 'POST',
          data: JSON.stringify(params),
        },
      );

      if (response.data.status) {
        if (response.data.data.options.length >= 0) {
          setOptionSeat(response.data.data.options);
        } else {
          alert('Tidak ada kursi yang bisa di reservasi');
        }
      }
    } catch (error) {}
  };

  const handleReservSeat = async () => {
    if (seatMapSelectId.length > 0) {
      try {
        if (priceSeatSelected !== 0) {
          if (paymentMethod === '') {
            setDisableRes(false);
            return alert('Pilih Metode Pembayaran');
          }
        }

        setDisableRes(true);
        const keys = key.split('-');
        const booking_id = keys[1].trim();

        const params = {
          seat_selected: seatMapSelectId.join(','),
          ticket_id: selectedTicketId,
          booking_id: booking_id,
          email: customerData?.email,
          payment_method: paymentMethod,
        };

        const response = await axios(
          `${process.env.REACT_APP_API_URL}/seating-soul-extra/selectSeat`,
          {
            headers: {
              'Content-Type': 'application/json',
              token: process.env.REACT_APP_API_KEY,
            },
            method: 'POST',
            data: JSON.stringify(params),
          },
        );

        if (response.data.status) {
          if (response.data.data.type === 'free') {
            alert(
              'Kursi berhasil di reservasi, check email anda untuk melihat invoice reservasi kursi. Terimakasih',
            );
            setDisableRes(false);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else if (response.data.data.type === 'paid') {
            setDisableRes(false);
            window.location.href = response.data.data.redirect;
          } else {
            setDisableRes(false);
            alert('Kursi Sudah Dipesan, Mohon Maaf');
          }
        } else {
          setDisableRes(false);
        }
      } catch (error) {
        setDisableRes(false);
      }
    } else {
      alert('Tidak ada kursi yang di pilih');
    }
  };

  const getSeatMap = async (ids, ticket_id, loc) => {
    try {
      setSelectedIds(ids.map((item) => item.id));
      const params = {
        ticket_id: ticket_id,
        loc2stage: loc,
      };
      const response = await axios(
        `${process.env.REACT_APP_API_URL}/seating-soul-extra/getDataMaps`,
        {
          headers: {
            'Content-Type': 'application/json',
            token: process.env.REACT_APP_API_KEY,
          },
          method: 'POST',
          data: JSON.stringify(params),
        },
      );

      if (response.data.status) {
        setSeatMap(response.data.data);
        setModalSeatMap(true);
      }
    } catch (error) {}
  };

  function getAllNames(options) {
    const names = [];
    options.forEach((group) => {
      names.push(
        `${group.name} ${
          group.loc2stage === 'right'
            ? '(B)'
            : group.loc2stage === 'left'
              ? '(A)'
              : group.loc2stage
                ? group.loc2stage
                : ''
        }`,
      );
    });

    return names.join(', ');
  }

  function getAllId(options) {
    const ids = [];
    options.forEach((group) => {
      ids.push(group.id);
    });

    setSeatMapSelectId(ids);
  }

  function getAllNamesNoLoc(options) {
    const names = [];
    options.forEach((group) => {
      names.push(group.name);
    });

    return names.join(',');
  }

  function getTotalPrice(options) {
    let totalSeatCharged = 0;

    options.forEach((group) => {
      if (group.seat_charged !== null) {
        // Jika seat_charged tidak null
        totalSeatCharged += parseFloat(group.seat_charged); // Menambahkan nilai seat_charged ke total
      }
    });

    return totalSeatCharged;
  }

  const handleSelectSeat = (index, id, seatSelect, ticket_id, price, item) => {
    setSeatSelect(id);
    setIndexSelect(index);
    setListSeatSelected(seatSelect);
    setPriceSeatSelected(price);
    setSelectedTicketId(ticket_id);
    scrollToSection(section3Ref);
    getAllId(item);
  };

  const combineTickets = (data) => {
    const result = {};

    data.forEach((item) => {
      const { ticket_name, seats } = item;

      if (!result[ticket_name]) {
        result[ticket_name] = {
          ticket_name,
          seats: [],
        };
      }

      result[ticket_name].seats.push(...seats);
    });

    // Ubah objek menjadi array dan gabungkan seats dengan koma
    return Object.values(result).map((item) => ({
      ticket_name: item.ticket_name,
      seats: item.seats.join(', '),
    }));
  };

  return (
    <Container className="home text-white" fluid>
      <Modal
        size="xl"
        centered
        show={modalSeatMap}
        onHide={() => setModalSeatMap(false)}
      >
        <Modal.Header closeButton>
          <b>Seat Map ({selectedSeatIds?.length} Seat)</b>
        </Modal.Header>
        <Modal.Body style={{ overflowX: 'auto', overflowY: 'auto' }}>
          <Seat
            seatData={seatMap}
            filter={selectedTicketIdRes}
            selectSeatIds={selectedSeatIds}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="btn-select-seat-select"
            onClick={() => setModalSeatMap(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {!imageLoaded && <LoadingScreen />} */}

      <Button
        className="btn-goto-wa"
        onClick={() =>
          getLink(
            `https://api.whatsapp.com/send/?phone=${csNumber}&text=Halo+Admin+Soul%2C+Saya+ingin+bertanya+tentang+Soul&type=phone_number&app_absent=0`,
          )
        }
      />

      <Col className="text-center">
        <Image
          className="img-hero"
          src={require('../images/soul/hero-extra.png')}
          loading="lazy"
        />
      </Col>
      <Col className="ticket-box">
        <Form>
          <Form.Label>Email</Form.Label>
          <InputGroup className="mb-1">
            <Form.Control
              type="email"
              id="email"
              className="input-email mb-1"
              onChange={(e) => setEmailVal(e.target.value)}
              value={emailVal}
              placeholder="Masukkan e-mail"
              required
              readOnly={emailStatus}
            />
            <InputGroupText
              className="input-email-check mb-1"
              onClick={() =>
                emailStatus ? handleRemoveState() : handleBooking()
              }
            >
              {emailStatus ? 'Change Email' : 'Check Email'}
            </InputGroupText>
          </InputGroup>
          <div className="d-flex">
            <Info fill="red" stroke="#020C2B" className="me-2" size={35} />
            <h6 className="m-0 fw-lighter">
              Masukkan email yang Anda gunakan saat memesan tiket untuk memilih
              kursi.
            </h6>
          </div>
        </Form>
      </Col>
      {bookingStatus && (
        <>
          <div className="text-center mb-4 mt-4">
            <Image
              src={require('../images/soul/booking_info.png')}
              className="w-75"
            />
          </div>
          <Col className="booking-detail mb-3">
            <div className="fw-lighter d-flex align-items-center mb-2">
              <Mail className="me-1" />{' '}
              <h6 className="text-white m-0">{customerData?.email}</h6>
            </div>
            <div className="fw-lighter d-flex align-items-center">
              <User className="me-1" />{' '}
              <h6 className="text-white m-0">{customerData?.name}</h6>
            </div>
          </Col>

          {seatBooked.length > 0 && (
            <Col className="text-center">
              <Col>
                <Row className="px-3 text-start">
                  <Col xs={4} className="seat_pick_ul_line">
                    Category
                  </Col>
                  <Col xs={8} className="seat_pick_ul">
                    Seats
                  </Col>
                </Row>
                {seatBooked?.map((item, i) => {
                  return (
                    <Row className="px-3 text-start" key={i}>
                      <Col xs={4} className="seat_pick_ul_s_line">
                        {item?.ticket_name}
                      </Col>
                      <Col
                        xs={8}
                        className="seat_pick_ul_s"
                        style={{ overflowX: 'auto' }}
                      >
                        {`${item?.seats}, `}
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Col>
          )}

          {bookingData.length > 0 ? (
            <>
              <Col className="text-center">
                <Image
                  src={require('../images/soul/pick_seat.png')}
                  className="mb-3 mt-5"
                  style={{ width: '80%' }}
                />
              </Col>
              <Col className="py-3">
                <Tabs
                  defaultActiveKey="profile"
                  className="mb-3 tabs-ticket"
                  activeKey={key}
                  onSelect={(k) => [setKey(k), getRecomendation(k)]}
                  style={{ borderRadius: '5px' }}
                  fill
                >
                  {bookingData?.map((item, i) => (
                    <Tab
                      key={i}
                      eventKey={`${item.ticket_id}-${item.booking_code}`}
                      style={{ borderRadius: '5px' }}
                      title={
                        <>
                          <h6 style={{ marginBlock: '-1px' }}>
                            <b>{item.name}</b>
                          </h6>
                          <span>({item.allocated_seat} Seat)</span>
                        </>
                      }
                    >
                      <Table responsive="xl" bordered striped className="mb-0">
                        <thead>
                          <tr>
                            <th className="th-white-no">Aksi</th>
                            <th className="th-white">Rekomendasi Kursi</th>
                            <th className="th-white">Total Reservasi</th>
                          </tr>
                        </thead>
                      </Table>
                      <Col style={{ maxHeight: '430px', overflow: 'scroll' }}>
                        <Table responsive="xl" bordered striped>
                          <tbody>
                            {optionSeat?.map((item, i) => (
                              <tr
                                key={i}
                                style={
                                  indexSelect === i
                                    ? {
                                        borderTop: '2px solid #1B4A3A',
                                        borderBottom: '2px solid #1B4A3A',
                                      }
                                    : {}
                                }
                              >
                                <td className="text-center align-items-center">
                                  <Button
                                    className={`btn-select-seat${
                                      item[0].name === selectedSeat
                                        ? '-select'
                                        : ''
                                    }`}
                                    onClick={() =>
                                      handleSelectSeat(
                                        i,
                                        item[0].name,
                                        getAllNamesNoLoc(item),
                                        item[0].ticket_id,
                                        getTotalPrice(item),
                                        item,
                                      )
                                    }
                                  >
                                    Pilih
                                  </Button>
                                </td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                  <b>{getAllNames(item)}</b>
                                  <br />
                                  <Button
                                    className="mt-3 btn-map-view"
                                    onClick={() => [
                                      getSeatMap(
                                        item,
                                        item[0].ticket_id,
                                        item[0].loc2stage,
                                      ),
                                      getAllId(item),
                                    ]}
                                  >
                                    Lihat Denah{' '}
                                    <Eye
                                      style={{ marginTop: '-5px' }}
                                      size={17}
                                    />
                                  </Button>
                                </td>
                                <td>
                                  Rp {formatNumberWithout(getTotalPrice(item))}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Col>
                    </Tab>
                  ))}
                </Tabs>
              </Col>

              <Col ref={section3Ref}>
                <p>
                  <i>
                    *Batas reservasi hanya{' '}
                    <span className="text-danger">
                      <b>15 menit</b>
                    </span>{' '}
                    sampai waktu pembayaran habis
                  </i>
                </p>
                <p>
                  <i>
                    *Jika Anda prefer untuk tidak memilih kursi, sistem akan
                    secara otomatis menentukan nomor kursi <b>(FREE)</b>
                  </i>
                </p>
                <p>
                  <i>
                    {
                      '*Invoice reservasi kursi akan dikirim ke email anda setelah dipesan :)'
                    }
                  </i>
                </p>
                {priceSeatSelected === 0 || priceSeatSelected === '' ? (
                  <></>
                ) : (
                  <>
                    <Col className="text-center">
                      <Image
                        className="w-75 mb-2"
                        src={require('../images/soul/payment-method.png')}
                        loading="lazy"
                      />
                    </Col>
                    <Col className="ticket-box-payment mb-4">
                      <Col
                        className="payment-select d-flex align-items-center"
                        onClick={() => setPaymentMethod('BRI')}
                      >
                        <Form.Check
                          value={'BRI'}
                          checked={paymentMethod === 'BRI' && true}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="mx-2"
                          type="radio"
                          id="payment_method"
                          name="payment_method"
                        />
                        <Image
                          src={require('../images/mobile/bank/bri.png')}
                          style={{
                            width: '20%',
                            height: '100%',
                            marginRight: '10px',
                          }}
                        />
                        <h6 className="fw-lighter text-black">
                          BRI VIRTUAL ACCOUNT
                        </h6>
                      </Col>
                      <Col
                        className="payment-select d-flex align-items-center"
                        onClick={() => setPaymentMethod('BNI')}
                      >
                        <Form.Check
                          value={'BNI'}
                          checked={paymentMethod === 'BNI' && true}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="mx-2"
                          type="radio"
                          id="payment_method"
                          name="payment_method"
                        />
                        <Image
                          src={require('../images/mobile/bank/bni.png')}
                          style={{
                            width: '20%',
                            height: '100%',
                            marginRight: '10px',
                          }}
                        />
                        <h6 className="fw-lighter text-black">
                          BNI VIRTUAL ACCOUNT
                        </h6>
                      </Col>
                      <Col
                        className="payment-select d-flex align-items-center"
                        onClick={() => setPaymentMethod('BSI')}
                      >
                        <Form.Check
                          value={'BSI'}
                          checked={paymentMethod === 'BSI' && true}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="mx-2"
                          type="radio"
                          id="payment_method"
                          name="payment_method"
                        />
                        <Image
                          src={require('../images/mobile/bank/bsi.png')}
                          style={{
                            width: '20%',
                            height: '100%',
                            marginRight: '10px',
                          }}
                        />
                        <h6 className="fw-lighter text-black">
                          BSI VIRTUAL ACCOUNT
                        </h6>
                      </Col>
                      <Col
                        className="payment-select d-flex align-items-center"
                        onClick={() => setPaymentMethod('MANDIRI')}
                      >
                        <Form.Check
                          value={'MANDIRI'}
                          checked={paymentMethod === 'MANDIRI' && true}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="mx-2"
                          type="radio"
                          id="payment_method"
                          name="payment_method"
                        />
                        <Image
                          src={require('../images/mobile/bank/mandiri.png')}
                          style={{
                            width: '20%',
                            height: '100%',
                            marginRight: '10px',
                          }}
                        />
                        <h6 className="fw-lighter text-black">
                          MANDIRI VIRTUAL ACCOUNT
                        </h6>
                      </Col>
                      <Col
                        className="payment-select d-flex align-items-center"
                        onClick={() => setPaymentMethod('QRIS')}
                      >
                        <Form.Check
                          value={'QRIS'}
                          checked={paymentMethod === 'QRIS' && true}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="mx-2"
                          type="radio"
                          id="payment_method"
                          name="payment_method"
                        />
                        <Image
                          src={require('../images/mobile/bank/QRIS-1.png')}
                          style={{
                            width: '20%',
                            height: '100%',
                            marginRight: '10px',
                          }}
                        />
                        <h6 className="fw-lighter text-black">QRIS</h6>
                      </Col>
                    </Col>
                  </>
                )}
                <Form.Label>Kursi Dipilih</Form.Label>
                <Form.Control
                  className="input-email mb-3"
                  readOnly={true}
                  value={listSeatSelected}
                />
                <Form.Label>Total Reservasi</Form.Label>
                <Form.Control
                  className="input-email mb-4 "
                  readOnly={true}
                  value={`Rp ${formatNumberWithout(priceSeatSelected)}`}
                />
                <Button
                  className="btn-buy-now-ticket"
                  disabled={disableRes}
                  onClick={() => handleReservSeat()}
                >
                  Reservasi Kursi
                </Button>
              </Col>
            </>
          ) : (
            <div 
            // className="text-center mb-4 mt-4"
            >
              {/* <Image
                src={require('../images/soul/no-booking.png')}
                className="w-100"
              /> */}
            </div>
          )}
        </>
      )}
    </Container>
  );
};

export default Home;
